import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerticalFormComponent } from './vertical-form/vertical-form.component';
import { VerticalListComponent } from './vertical-list/vertical-list.component';
import { VerticalRoutingModule } from './vertical-routing.module';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    VerticalFormComponent,
    VerticalListComponent
  ],
  imports: [
    CommonModule,
    VerticalRoutingModule,
    AngularMaterialModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class VerticalModule { }
